// extracted by mini-css-extract-plugin
export default {"container":"companion_container__dgnDH"};